// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 222) return "static/chunks/vendors.sravni-4fff234419d1b86d.js";
	if (chunkId === 893) return "static/chunks/893-58ed2ecf7c5664f3.js";
	if (chunkId === 300) return "static/chunks/300-24a8e4da868976f7.js";
	if (chunkId === 242) return "static/chunks/242-48955aa5e3cae43a.js";
	if (chunkId === 637) return "static/chunks/637-befa03dacb073ab8.js";
	if (chunkId === 388) return "static/chunks/388-e4aff4f32e1e9745.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"296":"ea88be26","987":"react-lottie"}[chunkId] || chunkId) + "." + {"203":"f6474b468c85406a","296":"708e47fd560a6f87","458":"bdeb701634f638bc","548":"124e9fbb6c3daf70","562":"ec6e2ace869d3930","606":"4ff55106b83fa3f2","987":"932b9eecaffb4c28"}[chunkId] + ".js";
};